/* eslint-disable */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
/* eslint-disable no-loop-func */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable quote-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import axios from 'axios';
import Tour from 'reactour';
import { Redirect } from 'react-router';
import Popup from 'reactjs-popup';


import ReactTooltip from 'react-tooltip';
import QuickActionModal from '../../components/Modals/QuickActionModal/QuickActionModal';
import Classes from './ManagerScreen.css';
import Aux from '../../hoc/Aux';
import OnlineSongManager from '../../components/OnlineSongManager/OnlineSongManager';
import socket from '../../SocketManager';
import NextSongControllable from '../../components/NextSongControllable/NextSongControllable';
import MConfig from '../../moramma-config.json';
import logger from '../../logger';
import helpers from '../../helpers/helpers';
import MenuPlaylistItem from '../../components/MenuPlaylistItem/MenuPlaylistItem';
import lang from '../../lang.json';

class ManagerScreen extends Component {
    state = {
      socket: {
        signature: 'nextsong-signature'
      },
      roomName: null,
      songs: [],
      onlineSong: -1,
      songTimeout: [],
      autoplay: true,
      logged: true,
      showblock: true,
      // socketReconnection: false,
      userData: null,
      startOffsetSongProposedFromFallback: 0,
      stopOffsetSongProposedFromFallback: 4,
      minSongToTriggerFallback: 4,
      connectedUsers: 0, 
      language: 'IT-it',
      isTourOpen: false,
      socketActive: false,
      songHistoryYesterday: [],
      songHistoryToday: [],
      songHistory: [],
    }

    // menuPlaylistList: [],

    async componentDidMount() {
      // Retrive data from API
      await this.fetchUserData();

      // Start all socket.io event handler
      this.startSocketEvents();

      // Retrive spot status from API
      await this.fetchActualSpotStatus();   

      await this.fetchSpotHistory();
    }

    changeLanguage = () => {
      if (this.state.language === 'IT-it') {
        this.setState({ language: 'EN-en' });
      } else {
        this.setState({ language: 'IT-it' });
      }
    }

    /**
     * @description Clear all data (atm the token) from localstorage
     */
    logOut = () => {
        logger.error('[ManagerScreen|skipSong] Local token not found');
        socket.removeAllListeners('connect');
        socket.removeAllListeners('client-join-channel');
        socket.removeAllListeners('server-ack-id-validation');
        socket.removeAllListeners('server-new-song');
        socket.removeAllListeners('r-server-new-song');
        socket.removeAllListeners('r-server-song-go-online');
        socket.removeAllListeners('server-default-playlist-changed');
        socket.removeAllListeners('server-delete-all-songs');
        socket.removeAllListeners('server-owner-data-updated');
        socket.removeAllListeners('r-server-delete-song');
        socket.removeAllListeners('disconnect');
        socket.removeListener();
        socket.removeAllListeners();
        socket.disconnect();
      
      logger.debug('[ManagerScreen|logOut] Logging out ...');
      localStorage.clear();
      this.setState({ logged: false });
    }

    /**
     * @description fetch the spot manager data
     */
    fetchUserData = async () => {
      logger.debug('[ManagerScreen|fetchUserData] Fetching user data ...');
      const localtoken = localStorage.getItem('API');
      if (!localtoken) {
        logger.error('[ManagerScreen|fetchUserData] Local token not found');
        this.logOut();
      }

      // Call 
      await axios({
        method: 'post',
        url: `${MConfig.BASE_API}/react/user`,
        headers: {
          Authorization: `Bearer ${localtoken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: { token: localtoken }
      }).then(async items => {
        console.log(items)
        // Update state
        // this.setState({ roomName: items.data.data.location.name, userDefaultPlaylist: items.data.data.defaults.defaultPlaylist, userData: items.data.data.location });        
        this.setState({ roomName: items.data.data.location.name, userData: items.data.data, language: items.data.data.owner.language }); 

        if(items.data.data.owner.login_attempts.length <= 1) {
          this.setState({ isTourOpen: true });
        }
       // console.log('usedata', items.data.data);

        // this.setState({ menuPlaylistList: tmpPlaylistList });

      //  console.log('userdata', this.state.userData);     
      }).catch(err => {
        logger.error('[ManagerScreen|fetchUserData] Error during  API/react/user call', err);
        this.logOut();
      });
    };

    /**
     * @description fetch the spot data
     */
    fetchActualSpotStatus = async () => {
      // logger.debug('[ManagerScreen|fetchActualSpotStatus] Fetching spot data ...');
      const localtoken = localStorage.getItem('API');
      if (!localtoken) {
        logger.error('[ManagerScreen|fetchActualSpotStatus] Local token not found');
        this.logOut();
      }
     
      await axios({
        method: 'get',
        url: `${MConfig.BASE_API}/rooms/${this.state.roomName}/songs`,
        headers: {
          'Authorization': `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then(items => {
        // Update with all songs
        this.onNewSongHandler(items.data.data);

        // Retrive online song from state and make it online
        this.setOnlineSong();
        
        this.checkFallbackPlaylist();
      }).catch(err => {
        logger.error('[ManagerScreen|fetchActualSpotStatus] Error during API/rooms/x/songs call', err);
        // todo: add banner
      });  
    };

    /**
     * @description fetch the spot data
     */
    fetchSpotHistory = async () => {
      // logger.debug('[ManagerScreen|fetchActualSpotStatus] Fetching spot data ...');
      const localtoken = localStorage.getItem('API');
      if (!localtoken) {
        logger.error('[ManagerScreen|fetchSpotHistory] Local token not found');
        this.logOut();
      }
     
      await axios({
        method: 'get',
        url: `${MConfig.BASE_API}/rooms/${this.state.roomName}/songs/all`,
        headers: {
          'Authorization': `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then(items => {
        // Update with all songs

        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        yesterday.setHours(0,0,0,0);

        let today = new Date();
        today.setHours(0,0,0,0);

        let filteredYesterdayData = items.data.data.filter((d) => {
          return d.insertionTime >= yesterday.toISOString() && d.insertionTime <= today.toISOString();
        });

        let filteredTodayData = items.data.data.filter((d) => {
          return d.insertionTime >= today.toISOString();
        });
        
        this.setState({
          songHistoryYesterday: filteredYesterdayData,
          songHistoryToday: filteredTodayData,
          songHistory: items.data.data
        })

      }).catch(err => {
        logger.error('[ManagerScreen|fetchSpotHistory] Error during API/rooms/x/songs/all call', err);
        // todo: add banner
      });  
    };

    /**
     * @description fetch the spot data
     */
    SocketResyncSpotStatus = async () => {
      // logger.debug('[ManagerScreen|fetchActualSpotStatus] Fetching spot data ...');
      const localtoken = localStorage.getItem('API');
      if (!localtoken) {
        logger.error('[ManagerScreen|fetchActualSpotStatus] Local token not found');
        this.logOut();
      }
     
      await axios({
        method: 'get',
        url: `${MConfig.BASE_API}/rooms/${this.state.roomName}/songs`,
        headers: {
          'Authorization': `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then(items => {
        // Update with all songs
        
     //   console.log('for resync', items.data.data);
        this.onNewSongHandlerForResync(items.data.data);

        // Retrive online song from state and make it online
       // this.setOnlineSong();
        
        this.checkFallbackPlaylist();
      }).catch(err => {
        logger.error('[ManagerScreen|fetchActualSpotStatus] Error during API/rooms/x/songs call', err);
        // todo: add banner
      });  
    };

    alivenessPollingEvent = () => {
      if (this.state.songs && this.state.onlineSong) {
        const payload = {
          createdAt: new Date().getTime(),
          spotType: 'web',
          spotName: this.state.roomName,
          idOnlineSong: this.state.onlineSong.id,
          qtaNextSongs: this.state.songs.length
        };
  
        socket.emit('aliveness-polling', payload);
      }
      setTimeout(this.alivenessPollingEvent, 5000);
    }

    startSocketEvents = () => {
      // socket.connect();
      socket.on('connect', async () => {
        // console.error('scket', sockett.client.conn.server.clientsCount);
        logger.debug('[ManagerScreen|connect] Called');
        this.setState({ socketActive: false })
        // remove 'disconnected from server' banner
        // Retrive spot status from API
        // await this.SocketResyncSpotStatus();   
      });    

      this.alivenessPollingEvent();

      socket.emit('client-join-channel', { customId: this.state.socket.signature, room: this.state.roomName });

      // moved outside connect
      socket.emit('react-subscribe-id', { customId: this.state.socket.signature, room: this.state.roomName });
      // socket.emit('react-subscribe-id', { customId: this.state.socket.signature, room: this.state.roomName });
      this.setState({ showblock: false });
      logger.debug('[ManagerScreen|connect] SOCKET.IO react-subscribe-id');
      logger.debug('[ManagerScreen|connect] socket.io is connected');

      // wait ack
      // TODO: repace with jwt
      socket.on('server-ack-id-validation', () => {
        logger.debug('[ManagerScreen|server-ack-id-validation] Called');
      });

      /**
      * Received new array of songs
      * TODO: REVIEW HERE
      */
      socket.on('server-new-song', (data) => {
        logger.debug('[ManagerScreen|server-new-song] Called. Received new song(s)', data);

        this.onNewSongHandler(data);
        /*
        const oldSongs = this.state.songs;
        const newSongs = oldSongs.concat(data);
            
        newSongs.sort(helpers.compare);

        // update state
        this.setState({ songs: newSongs });*/
      });
    
      /**
       * Received new song
       */
      socket.on('r-server-new-song', (data) => {
        logger.debug('[ManagerScreen|r-server-new-song] Called');
        this.onNewSongHandler(data);                
      });

      /**
       * All songs has been deleted, refresh it
       */
      socket.on('server-delete-all-songs', (data) => {
        logger.debug('[ManagerScreen|server-delete-all-songs] Called');
        this.onSongsDeleted(data);                
      });

      /**
       * song is deleted
       */
      socket.on('r-server-delete-song', (data) => {
        logger.debug('[ManagerScreen|r-server-delete-song] Called');
        this.onSongDeleted(data.song);                
      });

 
      socket.on('disconnect', (reason) => {
        //socket.emit('client-leave-channel', { customId: this.state.socket.signature, room: this.state.roomName });
        logger.error('[ManagerScreen|connect_error] disconnect', reason);
        socket.removeAllListeners('connect');
        socket.removeAllListeners('client-join-channel');
        socket.removeAllListeners('server-ack-id-validation');
        socket.removeAllListeners('server-new-song');
        socket.removeAllListeners('r-server-new-song');
        socket.removeAllListeners('r-server-song-go-online');
        socket.removeAllListeners('server-default-playlist-changed');
        socket.removeAllListeners('server-delete-all-songs');
        socket.removeAllListeners('server-owner-data-updated');
        socket.removeAllListeners('r-server-delete-song');
        socket.removeAllListeners('disconnect');
        socket.removeListener();
        socket.removeAllListeners();
        socket.connect();
        this.startSocketEvents();
      });

      socket.on('r-server-song-go-online', (payload) => {
        logger.error('ManagerScreen|r-server-song-go-online] Called');
        this.onNewSongHandler(payload.songs);
        this.setOnlineSong();
      });

     /* socket.on('client-connected-change', (payload) => {
        logger.debug('[NEXTSONG][componentDidMount() | client-connected-change] receive new data');

        if (payload.key === this.state.roomName) {
          this.setState({ connectedUsers: payload.value });
        }
      });*/


      socket.on('server-default-playlist-changed', (payload) => {
        logger.debug('[ManagerScreen][componentDidMount() | server-default-playlist-changed] receive new default playlist changes', payload);

        const oldUserdata = this.state.userData;
        oldUserdata.defaults.defaultPlaylist = payload;
        this.setState({ userData: oldUserdata });
      });

      socket.on('server-owner-data-updated', (payload) => {
        logger.debug('[ManagerScreen][componentDidMount() | server-owner-data-updated] receive new userdata changes', payload);

        let oldLang = this.state.language;
        oldLang = payload.owner.language;
        this.setState({ language: oldLang, userData: payload});
      });
    }

    /**
     * @description from state song list, take the song with type 'onAir' and make it online. Make the first of the list otherwise.
     */
    setOnlineSong = () => {
      const oldSongs = this.state.songs;

      const found = oldSongs.findIndex(el => el.type === 'onAir');

      if (found < 0) {
        // Song not found, make it first online
        
        const songToMakeOnline = oldSongs[0];
        logger.debug('[ManagerScreen|setOnlineSong] No songs to make online. Make it online the first of the list', songToMakeOnline);
        this.skipSong(songToMakeOnline);
      } else {
        // Found a song to make online
        const song = oldSongs[found];
        oldSongs.splice(found, 1);

        logger.debug(`[ManagerScreen|setOnlineSong] Founded a song wih onAir tag, making it online: ${song.id}`);
        this.setState({ songs: oldSongs, onlineSong: song, autoplay: true });
        this.autoSkipSongHandler(song);
      }
    };

    /**
     * @description force song skip. Event called from SKIP button. triggered from child
     */
    btnSkipEventHandler = () => {
      const oldSongs = this.state.songs;

      const found = oldSongs.findIndex(el => el.type === 'onAir');

      if (oldSongs.length < 1) {
        // cant skip! there is no more songs on the list
        // todo: call here auto song propose handler
        ToastsStore.warning('Unable to skip song. Please add songs to the list first.');
        return;
      }

      if (found < 0) {
        // Song not found, make it first online
        const songToMakeOnline = oldSongs[0];
        logger.debug(`[ManagerScreen|btnSkipEventHandler] Make it online the first of the list ${songToMakeOnline}`, songToMakeOnline);
      
        this.skipSong(songToMakeOnline);
      } else {
        // remove actual online song
        oldSongs.splice(found, 1);

        // make the first online
        const songToMakeOnline = oldSongs[0];

        if (songToMakeOnline) {
          this.skipSong(songToMakeOnline);
        }
      }
    }

    userClickHandler = (userName)  => {
      const history = this.state.songHistory.filter((el) => el.user.name === userName);
      alert("L'utente ha proposto altre " + history.length + " canzoni");
    }

    /**
     *  @description add song to react state
     *  @param [data] array of songs
     */
    onNewSongHandler = (data) => {
      //console.log('onNewSongHandler data', data);
      if((Array.isArray(data))){
        let oldSongs = this.state.songs;
        for(const el of data) {
          if (el.type !== 'pastSong'){            
            const index = oldSongs.findIndex(x => x.id === el.id);
  
            if (index === -1) {
              // adding song
              oldSongs = oldSongs.concat(el);
            } else {
              // replace with new data
              oldSongs.splice(index, 1);
              oldSongs = oldSongs.concat(el);
            }  
          }
        }

        oldSongs.sort(helpers.compare);
        this.setState({ songs: oldSongs });
      } else {
        if (data.type === 'onAir' || data.type === 'songVoted') {
          let oldSongs = this.state.songs;
          const index = oldSongs.findIndex(x => x.id === data.id);

          if (index === -1) {
            // adding song
            oldSongs = oldSongs.concat(data);
          } else {
            // replace with new data
            oldSongs.splice(index, 1);
            oldSongs = oldSongs.concat(data);
          }  

          oldSongs.sort(helpers.compare);
          this.setState({ songs: oldSongs });
        }
      }
      

     // console.log('onNewSongHandler', this.state.songs);
    }

    onSongsDeleted = (data) => {
      let oldSongs = this.state.songs;
      oldSongs = oldSongs.filter((el) => el.type === 'onlineSong');

      this.setState({ songs: oldSongs });
    }

    onSongDeleted = (song) => {
      let oldSongs = this.state.songs;
      oldSongs = oldSongs.filter((el) => el.id !== song.id);

      this.setState({ songs: oldSongs });
    }

    onNewSongHandlerForResync = (data) => {
      data.forEach((el) => {
        if (el.type === 'songVoted') {
          let oldSongs = this.state.songs;
          const index = oldSongs.findIndex(x => x.id === el.id);

          if (index === -1) {
            // adding song
            oldSongs = oldSongs.concat(el);
          } else {
            // replace with new data
            oldSongs.splice(index, 1);
            oldSongs = oldSongs.concat(el);
          }  

          oldSongs.sort(helpers.compare);
        
          this.setState({ songs: oldSongs });
        }
      });
      //console.log('canzoni onNewSongHandlerForResync:', this.state.songs);
    }

    /**
     * @description autoskip handler with timing
     */
    autoSkipSongHandler = (song) => {
      const timeout = [];
      this.clearTimeout();
      timeout.push(setTimeout(this.btnSkipEventHandler, (song.duration * 1000) + 3000));
      this.setState({ songTimeout: timeout });
      logger.debug(`[ManagerScreen|autoSkipSongHandler] Set an interval for autoskip for song:${song.id}, duration:${JSON.stringify((song.duration * 1000) + 3000)}`);
    }

    /**
     * @description handler when new song is voted
     */
    onNewSongVotedHandler = (data) => {
      let oldSongs = this.state.songs;

      // search song inside this.state
      const found = oldSongs.findIndex(el => el.id === data.id);

      if (found < 0) {
        // if song is new, add
        oldSongs = oldSongs.concat(data);
        logger.debug(`[ManagerScreen|onNewSongVotedHandler] Reveiced new vote. Unable to find song.id inside my list.. adding to next song. Song:${data.id}`);
      } else {
        // replace with new data
        oldSongs.splice(found, 1);
        oldSongs = oldSongs.concat(data);
        logger.debug(`[ManagerScreen|onNewSongVotedHandler] Reveiced new vote. Update song:${data.id}`);
      }

      oldSongs.sort(helpers.compare);

      // update state
      this.setState({ songs: oldSongs });
    };


    /**
     * @description skip song 
     */
    skipSong = (song) => {
      if (!song) {
        // ToastsStore.warning('Unable to skip song.');
        return;
      }

      const localtoken = localStorage.getItem('API');
      if (!localtoken) {
        
        this.logOut();
      }

      this.setState({ onlineSong: song });

      axios({
        method: 'put',
        url: `${MConfig.BASE_API}/rooms/${this.state.roomName}/songs/${song.id}/online`,
        headers: {
          Authorization: `Bearer ${localtoken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data: { token: localtoken, user: this.state.userData.location }
      }).then(() => {
        logger.debug(`[ManagerScreen|skipSong] API/rooms/${this.state.roomName}/songs/${song.id}/online OK (${song.name})`);
        this.checkFallbackPlaylist();
        this.fetchSpotHistory();
      }).catch(err => {
        logger.error('[ManagerScreen|skipSong] error during API/rooms/x/songs/x/online', err);
      });
    }

    /**
     * @description clear all timeouts. used for autoskip song
     */
    clearTimeout = () => {
      for (let i = 0; i < this.state.songTimeout.length; i += 1) {
        clearTimeout(this.state.songTimeout[i]);
      }

      logger.debug('[ManagerScreen|clearTimeout] Timeout Cleared.');

      // Quick reset of the timer array you just cleared
      this.setState({ songTimeout: [] });
    }
    
    /**
     * @description start player
     */
    playPlayerChildTrigger = () => {
      if (this.state.onlineSong) {
        const song = this.state.onlineSong;
        this.setState({ onlineSong: song, autoplay: true });
      }
    }

    /**
     * @description stop player
     */
    triggerStopPlayerFromChild = () => {
      logger.debug('[ManagerScreen|stopPlayerChildTrigger] Stop button pressed. Stopping autoskip trigger.');
      this.clearTimeout();
      this.setState({ autoplay: false });
    }

    checkFallbackPlaylist = async () => {
      const localtoken = localStorage.getItem('API');
      if (!localtoken) {
        logger.error('[ManagerScreen|skipSong] Local token not found');
        this.logOut();
      }

      const { songs } = this.state;

      // se le canzoni in lista sono più di 3, non eseguire l'algoritmo
      if (songs.length >= this.state.minSongToTriggerFallback) {
        return;
      }

      let fallbackSongs = [];
      // controllo che esista la default playlist, altrimenti, carico quella di fallback
      if (!this.state.userData.defaults.defaultPlaylist.songs) {
        fallbackSongs = this.state.userData.defaults.fallback.songs
      }
      else {
        fallbackSongs = this.state.userData.defaults.defaultPlaylist.songs;
      }
      
      // contatori
      let proposedWithSuccess = 0; // conta quante canzoni sono state proposte con successo
      let cycleCounter = 0; // conta quanti cicli sono stati fatti (max 5, le default playlist sono da 25 canzoni minimo)

      // ciclo finchè non vengono proposte almeno 4 canzoni, oppure sono state superate le 5 iterazioni
      do {
        let i = this.state.startOffsetSongProposedFromFallback; // parte da 0 la prima volta
        let nextStart = i;
        let nextStop = 0;

        // eseguo 4 iterazioni la prima volta (da 0 a 4)
        while(i <= this.state.stopOffsetSongProposedFromFallback) {
          if(i >= fallbackSongs.length - 1) {
            break;
          }
          if(!fallbackSongs[i].song.id) {
            break;
          }
          i += 1;
          await axios({
            method: 'put',
            url: `${MConfig.BASE_API}/rooms/${this.state.userData.location.name}/songs/${fallbackSongs[i].song.id}`,
            headers: {
              'Authorization': `Bearer ${localtoken}`,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            }
          }).then(() => {
            // canzone proposta correttamente
            ToastsStore.success(`${fallbackSongs[i].song.title} proposed.`);
            proposedWithSuccess += 1;
          }).catch((err) => {
            // problemi mentre è stata proposta
            if(err.response.status === 404) {
              ToastsStore.error(`'${fallbackSongs[i].song.title}' not available in your country.`);
            }
            else if(err.response.status === 429) {
              ToastsStore.error(`'${fallbackSongs[i].song.title}' already proposed.`);
            }
            else 
            {
              ToastsStore.error(`Unable to propose ${fallbackSongs[i].song.title}.`);
            }
           
            console.error('proposeAllSongs', err);
          });  

          
        }

        nextStart = i;
        nextStop = nextStart + 4;
        if (nextStop >= fallbackSongs.length - 1) {
          this.setState({ startOffsetSongProposedFromFallback: 0, stopOffsetSongProposedFromFallback: 4 });
          cycleCounter += 1;
        } else {
          this.setState({ startOffsetSongProposedFromFallback: nextStart, stopOffsetSongProposedFromFallback: nextStop });
        }
      } while(proposedWithSuccess < 4 && cycleCounter <= 2)

    }

    /**
     *   const { songs } = this.state;
      let fallbackSongs = [];
      fallbackSongs = this.state.userData.defaults.defaultPlaylist.songs;

      const recoveryPlaylist = this.state.userData.defaults.fallback.songs;

      if (!fallbackSongs || fallbackSongs.length < 5) {
        fallbackSongs = this.state.userData.playlists[0].songs;
      }

      if (songs.length >= this.state.minSongToTriggerFallback) {
        return;
      }

      let proposedWithSuccess = 0;
      const maxCycle = 6;
      let maxCycleCounter = 0;

      do {
        maxCycleCounter += 1;
        let i = 0;
        let nextStart = i;
        let nextStop = 0;
        for (i = this.state.startOffsetSongProposedFromFallback; i <= this.state.stopOffsetSongProposedFromFallback; i += 1) {
          await axios({
            method: 'put',
            url: `${MConfig.BASE_API}/rooms/${this.state.userData.location.name}/songs/${fallbackSongs[i].song.id}`,
            headers: {
              'Authorization': `Bearer ${localtoken}`,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            }
          }).then(() => {
            ToastsStore.success(`${fallbackSongs[i].song.title} proposed.`);
            proposedWithSuccess += 1;
          }).catch(err => {
            ToastsStore.error(`Unable to propose ${fallbackSongs[i].song.title}. Check constraints.`);
            console.error('proposeAllSongs', err);
          });  
        }

        nextStart = i;
        nextStop = nextStart + 2;

        if (nextStart >= fallbackSongs.length) {
          this.setState({ startOffsetSongProposedFromFallback: 0, stopOffsetSongProposedFromFallback: 4 });
        } else {
          this.setState({ startOffsetSongProposedFromFallback: nextStart, stopOffsetSongProposedFromFallback: nextStop });
        }
      } while (proposedWithSuccess <= 5 && maxCycleCounter <= maxCycle);

      if (proposedWithSuccess <= 5) {
        // play recovery playlist
        let i = 0;
        for (i = 0; i <= 20; i += 1) {
          await axios({
            method: 'put',
            url: `${MConfig.BASE_API}/rooms/${this.state.userData.location.name}/songs/${recoveryPlaylist[i].song.id}`,
            headers: {
              'Authorization': `Bearer ${localtoken}`,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            }
          }).then(() => {
            ToastsStore.success(`${fallbackSongs[i].song.title} proposed from recovery playlist.`);
          }).catch(err => {
            ToastsStore.error(`Unable to propose ${fallbackSongs[i].song.title} proposed from recovery playlist. Check constraints.`);
            console.error('proposeAllSongs', err);
          });  
        }
      }
     */

    closeTour = () => {
      this.setState({ isTourOpen: false });
    }

    startGuide= () => {
      this.setState({ isTourOpen: true });
    }

    componentDidCatch(error, info) {
      // Display fallback UI
      // You can also log the error to an error reporting service
      console.error('componentDidCatch', error, info);
    }

    render() {
      if (this.state.logged === false) {
        return <Redirect to="/logout" />;
      }
      if (this.state.showblock) {
        return <p className={Classes.SectionOpenPbScreen}>No connection avialable. Please refresh the page.</p>;
      }
      const steps = [
        {
          selector: '[data-tut="reactour_login_deezer"]',
          content: 'Esegui il login a deezer Premium! Se non appare o parte la canzone, ricarica la pagina!',
        },
        {
          selector: '[data-tut="reactour_song_control"]',
          content: 'Controlla le canzoni con stop, play e skip"',
        },
        {
          selector: '[data-tut="reactour_atm_online"]',
          content: 'Informazioni canzone in riproduzione',
        },
        {
          selector: '[data-tut="reactour_pb"]',
          content: 'Apri la schermata visibile al pubblico',
        },
        {
          selector: '[data-tut="reactour_settings"]',
          content: 'Apri le impostazioni dello spot',
        },
        {
          selector: '[data-tut="reactour_actions"]',
          content: 'Esegui delle azioni rapide sullo spot',
        }
      ];

      return (
        <Aux>     
          <Tour
            steps={steps}
            isOpen={this.state.isTourOpen}
            onRequestClose={this.closeTour}
          />
          <div className={Classes.BgOrange}>
            <br />
            <div className="row col-12 justify-content-center">
              <br />
              <a href="/pb-screen" target="_blank" className={Classes.NoDecoration} data-tut="reactour_pb">
                <div className={Classes.btnBlue}>
                  <p className={Classes.NoSpace}> 
                    <i className="fas fa-desktop" />
                    &nbsp;
                    {lang[this.state.language].pbscreen_menu_btn_pbscreen}
                  </p>  
                </div>
              </a>
              &nbsp;
              <a href="/config/home" target="_blank" className={Classes.NoDecoration} data-tut="reactour_settings">
                <div className={Classes.btnBlue}>
                  <p className={Classes.NoSpace}>
                    <i className="fas fa-user-cog" />
                    &nbsp;
                    {lang[this.state.language].pbscreen_menu_btn_settings}
                  </p>
                </div>  
              </a> 
              &nbsp;
              {
                /**
                 * <Popup 
                trigger={
                  (
                    <div className={Classes.btnBlue} data-tut="reactour_default_playlist">
                      <p className={Classes.NoSpace}> 
                        <i className="fas fa-compact-disc" />
                        &nbsp;
                        { lang[this.state.language].pbscreen_menu_btn_playlist}
                        : 
                        {
                          this.state.userData.defaults.defaultPlaylist.name 
                            ? this.state.userData.defaults.defaultPlaylist.name
                            : ''
                        }
                      </p>
                    </div> 
                   )} 
                position="bottom center"
              >
                {this.state.menuPlaylistList}
              </Popup>  
                 */
              }
              
              <a className={Classes.NoDecoration} onClick={this.startGuide} href="#">
                <div className={Classes.btnBlue}>
                  <p className={Classes.NoSpace}>
                    <i className="fas fa-info-circle" />
                    &nbsp;
                    {lang[this.state.language].pbscreen_menu_btn_info}
                  </p>
                </div> 
              </a>
              &nbsp;
              <Popup
                                 
                    trigger={<a className={Classes.NoDecoration} href="#" data-tut="reactour_actions">
                    <div className={Classes.btnBlue}>
                      <p className={Classes.NoSpace}>
                        <i className="fas fa-bolt" />
                        &nbsp;
                        Actions
                      </p>
                    </div> 
                  </a>}
                    modal
                    closeOnDocumentClick
                >
                    <QuickActionModal 
                    language={this.state.language}
                    songs={this.state.songs} />
                </Popup>
                &nbsp;
                <a data-tip="Supporto e tutorial" className={Classes.NoDecoration} target="_blank" href="https://moramma.com/FAQ-it.html">
                <div className={Classes.btnBlue}>
                  <p className={Classes.NoSpace}> 
                    <i className="far fa-question-circle" />
                  </p>
                </div> 
              </a>
              &nbsp;
                <a data-tip="Condivisione della musica" className={Classes.NoDecoration} target="_blank" href="/sharing">
                <div className={Classes.btnBlue}>
                  <p className={Classes.NoSpace}> 
                    <i className="fas fa-share-alt" />
                  </p>
                </div> 
              </a>
              &nbsp;
              <a className={Classes.NoDecoration} onClick={() => this.logOut()} href="#">
                <div className={Classes.btnBlue}>
                  <p className={Classes.NoSpace}> 
                    <i className="fas fa-sign-out-alt" />
                    &nbsp;
                    {lang[this.state.language].pbscreen_menu_btn_logout}
                  </p>
                </div> 
              </a> 
            </div>
            <ReactTooltip />
            <br />
            {
              this.state.userData.filters.genres.length > 0 ? (
                <div className="row col-12 justify-content-center">
                  <a className={Classes.NoDecoration} href="/config/filters" target="_blank">
                    <div className={Classes.btnOrange}>
                      <p className={Classes.NoSpace}> 
                        <i className="fas fa-filter" />
                        &nbsp;
                        {this.state.userData.filters.genres.length} filter active
                      </p>
                    </div> 
                  </a>
                </div>
              ) : (
                ''
              )
            }
            <div className="container">
              <OnlineSongManager
                song={this.state.onlineSong}
                skipfunction={this.btnSkipEventHandler}
                triggerStopPlayerFromChild={this.triggerStopPlayerFromChild}
                playPlayerChildTrigger={this.playPlayerChildTrigger}
                songAutoplay={this.state.autoplay}
                connectedUsers={this.state.connectedUsers}
                language={this.state.language}
                historyYesterday={this.state.songHistoryYesterday}
                historyToday={this.state.songHistoryToday}
                history={this.state.songHistory}
              />
            </div> 
          </div>
          <br />
          <div className="container">
            <NextSongControllable
              songs={this.state.songs}
              upcomingTitle={lang[this.state.language].upcoming_songs}
              roomName={this.state.roomName}
              userClickHandler={this.userClickHandler}
            />
          </div>
          <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />  
        </Aux>
      );
    }
} 

export default ManagerScreen;
